module.exports = __webpack_public_path__ + "static/media/octopus.7306dd4a.png";